<template>
  <ui-dialog show max-width="623px" @input="$emit('close')">
    <template #header>
      <h3>{{ $t("message.questionsAndAnswers.askQuestion") }}</h3>
    </template>
    <div class="step-indicator">
      <div
        v-for="step in indicatorSteps"
        :key="step.value"
        class="step-indicator__item"
        :class="{ 'is-active': step.value === currentStep }"
      >
        <div class="step-indicator__circle">{{ step.value }}</div>
        <div class="step-indicator__text">
          {{ step.text }}
        </div>
      </div>
    </div>
    <transition tag="div" name="toggle" mode="out-in">
      <keep-alive>
        <QaManageDialogLocationListView
          v-if="currentStep === 1"
          @next-step="handleNextStep"
          @close="$emit('close')"
        />
        <QaManageDialogQuestionView
          v-else-if="currentStep === 2"
          :selected-facility="selectedFacility"
          @submit="handleSubmit"
          @back="handleBack"
        />
      </keep-alive>
    </transition>
  </ui-dialog>
</template>

<script>
import QaManageDialogLocationListView from "./QaManageDialogLocationListView.vue";
export default {
  name: "QaManageDialog",
  components: {
    QaManageDialogQuestionView: () =>
      import("./QaManageDialogQuestionView.vue"),
    QaManageDialogLocationListView
  },
  data() {
    return {
      currentStep: 1,
      indicatorSteps: [
        {
          text: this.$t("message.questionsAndAnswers.selectLocation"),
          value: 1
        },
        {
          text: this.$t("message.questionsAndAnswers.questionAndAnswer"),
          value: 2
        }
      ],
      selectedFacility: null
    };
  },

  methods: {
    async handleSubmit({ formData, facility }) {
      const payload = {
        question: {
          text: formData.question,
          facility
        },
        answer: {
          text: formData.answer
        }
      };
      this.$emit("submit", payload);
    },
    handleNextStep(facilityData) {
      this.selectedFacility = facilityData;
      this.currentStep++;
    },
    handleBack() {
      this.currentStep--;
    }
  }
};
</script>

<style lang="scss" scoped>
.toggle-enter-active,
.toggle-leave-active {
  transition: opacity 0.3s;
}

.toggle-enter, .toggle-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}

.step-indicator {
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
  position: relative;

  &:before {
    content: "";
    height: 1px;
    width: 100%;
    position: absolute;
    background: $gray-300;
    top: 0;
    bottom: 0;
    margin: auto;
  }

  &__item {
    display: flex;
    align-items: center;
    gap: $spacing;
    color: $gray-2;
    background: white;
    position: relative;
    z-index: 1;
    padding: 0 $spacing * 2;
    transition: color 0.3s 0.2s;

    &.is-active {
      color: $grey-darker;

      .step-indicator__circle {
        background-color: $primary;
      }
    }
  }

  &__circle {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    background-color: $gray-2;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    @include font-size(12px);
    transition: background 0.3s 0.2s;
  }
}
::v-deep label,
::v-deep textarea {
  @include font-size(14px);
}
</style>
